/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {NumberUtils} from "@/lib/utils/numberUtils";
import {AnimatedSegmentTransitionModel} from "@/models/animatedSegmentTransitionModel";
import {BASIC_THEME_ID} from "@/models/animatedThemeModel";

export class AutoCreateConfigurationModel extends JsonModel<AutoCreateConfigurationModel.IJson> {
  public static default(attributes: Partial<AutoCreateConfigurationModel.IJson> = {}) {
    return new AutoCreateConfigurationModel({
      themeId: BASIC_THEME_ID,
      lottieVersion: "5.9.0",
      width: 1920,
      height: 1080,
      frameRate: 24,
      isTextEnabled: false,
      distributionStrategy: AutoCreateConfigurationModel.DistributionStrategy.Fit,
      transitionType: AnimatedSegmentTransitionModel.Type.None,
      ...attributes,
    });
  }

  public get width(): number {
    return this.json.width;
  }

  public get height(): number {
    return this.json.height;
  }

  public get aspectRatio(): number {
    return NumberUtils.round(this.json.width / this.json.height, 2);
  }

  public get themeId(): number {
    return this.json.themeId;
  }

  public get frameRate(): number {
    return this.json.frameRate;
  }

  public get lottieVersion(): string {
    return this.json.lottieVersion;
  }

  public get distributionStrategy(): AutoCreateConfigurationModel.DistributionStrategy {
    return this.json.distributionStrategy;
  }

  public get isTransitionEnabled(): boolean {
    return this.transitionType !== AnimatedSegmentTransitionModel.Type.None;
  }

  public get transitionType(): AnimatedSegmentTransitionModel.Type {
    return this.json.transitionType;
  }

  public get isTextEnabled(): boolean {
    return this.json.isTextEnabled;
  }
}

export namespace AutoCreateConfigurationModel {
  export interface IJson {
    themeId: number;
    width: number;
    height: number;
    frameRate: number;
    lottieVersion: string;
    distributionStrategy: DistributionStrategy;
    isTextEnabled: boolean;
    transitionType: AnimatedSegmentTransitionModel.Type;
  }

  export enum DistributionStrategy {
    All = "all",
    Fit = "fit",
    Short = "short",
  }
}
/* v8 ignore stop */
